import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Updates specification table rows when the selected variant changes.
 * Listens for variant:update and morphs from the re-fetched product HTML.
 *
 * @extends {Component}
 */
class SpecificationsAccordionComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSpecifications);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecifications);
  }

  /**
   * @param {import('./events').VariantUpdateEvent} event
   */
  updateSpecifications = (event) => {
    const newAccordion = event.detail.data.html.querySelector(
      `specifications-accordion-component[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newAccordion) return;

    morph(this, newAccordion, { childrenOnly: true });
  };
}

if (!customElements.get('specifications-accordion-component')) {
  customElements.define('specifications-accordion-component', SpecificationsAccordionComponent);
}
